import { Modal } from "react-bootstrap";
import { useContext } from "react";
import { DataContext } from "../DataContext";
import { Wrapper, CustomerProduct, CustomerShipping } from "../styles";
import { renderSizeAbbreviationHTML } from "../utils";
import { ASSET_URL } from "../constants";

export const ProductsTemplate = ({ order }) => {
  const paymentType = order?.billing.card.brand;
  const paymentLastFour = order?.billing.card.last4;
  const data = useContext(DataContext);
  function findSelectedDesign(designName) {
    const designObj = data.designs.find((design) => design.designName === designName);
    return designObj;
  }
  const renderProducts = () => {
    return order.products.map((product) => {
      const details = data.getProduct(product.productId);
      const designObject = findSelectedDesign(product.design);
      return (
        <CustomerProduct>
          <div className="product-image border">
            <picture>
              <source srcset={`${ASSET_URL}/designs/small/${designObject.designName}-logo.avif`} type="image/avif" />
              <img src={`${ASSET_URL}/designs/small/${designObject.designName}-logo.gif`} />
            </picture>
          </div>
          <div className="product-price">${details.cost}</div>
          <div className="product-size size-badge" dangerouslySetInnerHTML={{ __html: renderSizeAbbreviationHTML(product.size) }} />
          <div className="product-position">{product.position}</div>
          <div className="product-quantity">{product.quantity}</div>
        </CustomerProduct>
      );
    });
  };

  return (
    <Wrapper className="modal-styles order-products">
      <Modal.Header closeButton>
        <Modal.Title>
          Order # <strong>{order.orderNumber}</strong>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CustomerShipping>
          {order?.shipping && (
            <div>
              <div>
                <strong>Shipping Address</strong>
              </div>
              <div>{order.shipping.name}</div>
              <div>{order.shipping.address.line1}</div>
              {order.shipping.address.line2 && <div>{order.shipping.address.line2}</div>}
              <div>
                {order.shipping.address.city} {order.shipping.address.state} {order.shipping.address.postal_code}{" "}
              </div>
            </div>
          )}
          {order?.billing && (
            <div>
              <div>
                <strong>Billing Details</strong>
              </div>
              <div>{order.billing.name}</div>
              <div>{order.billing.address.line1}</div>
              {order.billing.address.line2 && <div>{order.billing.address.line2}</div>}
              <div>
                {order.billing.address.city} {order.billing.address.state} {order.billing.address.postal_code}{" "}
              </div>
            </div>
          )}
        </CustomerShipping>
        <div className="table-header products box-padding-2030">
          <div className="product-image-header">Design</div>
          {/* <div className="product-name">
            <strong>Description</strong>
          </div> */}
          {/* <div>
            <strong>Design</strong>
          </div> */}
          <div className="product-price-header">Price</div>
          <div className="product-size-header">Size</div>
          <div className="product-position-header">Position</div>
          <div className="product-quantity-header">Qty</div>
        </div>
        <div className="table-body products">{renderProducts()}</div>
        <div className="order-footer box-padding-2030">
          <div>
            <div>
              <div>
                <strong>Payment Method</strong>
              </div>
              <div>
                {paymentType} ({paymentLastFour})
              </div>
            </div>
          </div>
          <div className="price-details">
            <div className="order-footer-labels">
              <span>Subtotal</span>
              <span>Shipping</span>
              {order.salesTax > 0 && <span>Sales Tax</span>}
              <span>Total</span>
            </div>
            <div className="order-footer-values">
              <span>${order.subTotal.toFixed(2)}</span>
              <span>${order.shippingRate.toFixed(2)}</span>
              {order.salesTax > 0 && <span>${order.salesTax.toFixed(2)}</span>}
              <span>${order.total.toFixed(2)}</span>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Wrapper>
  );
};
